/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_DEVOPS_PROVIDERS } from './resourceTypeDevopsProviders.constants.tsx';
import type { DevOpsProviderResult } from './DevOpsProviderResult.types.tsx';

export const devOpsProviderResource: RouteResource<DevOpsProviderResult> =
	createResource<DevOpsProviderResult>({
		type: RESOURCE_TYPE_DEVOPS_PROVIDERS,
		getKey: () => 'state',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-devops-providers", jiraSpaEntry: "async-resource-devops-providers" */ './getData.tsx'
			),
		maxAge: 60 * 1000,
	});

export const useDevOpsProviderResource = (): UseResourceHookResponse<DevOpsProviderResult> =>
	useResource<DevOpsProviderResult>(devOpsProviderResource);
